import { merge } from 'ramda';

type Response = {
  result?: Record<string, unknown>;
};

type Error = {
  result?: Record<string, unknown>;
  body?: string;
};

export const responseFormatter = (
  response: Response = {},
  additionalInfo: Object = {},
) => merge(response.result, additionalInfo);

export const errorFormatter = (
  { result, body }: Error,
  displayMessage: string,
) => merge(result || { body }, { displayMessage });

const MORE_INFO_MESSAGE = 'Please contact support for more details.';

export const RESPONSE_SUCCESS = { success: true };
export const TOKEN_FAILURE = `We weren't able to connect to Google Drive at this time. ${MORE_INFO_MESSAGE}`;
export const TEMPLATE_COPY_FAILURE = `We weren't able to copy the Google Drive files. ${MORE_INFO_MESSAGE}`;
export const SLIDE_BATCH_UPDATE_FAILURE = `We weren't able to update the Google Slide presentation. ${MORE_INFO_MESSAGE}`;
